import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CommandRequestDetailsModalComponent } from '../command-request-details-modal/command-request-details-modal.component';
import { CommandRequestRecord } from '../services/device-command-scheduler.service';

@Component({
  selector: 'command-request-details-modal-link',

  template: `
    <div class="cell-modal-link">
        <a class="cell-modal-link__link" (click)="openModal()">{{commandRequest.commandRequestId}}</a>
    </div>`
})
export class CommandRequestDetailsModalLinkComponent implements ICellRendererAngularComp {

  constructor(private modalService: NgbModal) { }

  public commandRequest: CommandRequestRecord;

  openModal() {
    const modal = this.modalService.open(CommandRequestDetailsModalComponent, { size: 'lg', windowClass: "lytxModal", centered: true });
    modal.componentInstance.commandRequest = this.commandRequest;
  }

  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    this.commandRequest = params.data;
  }

  // gets called whenever the cell refreshes
  refresh(params: ICellRendererParams): boolean {
    // set value into cell again
    this.commandRequest = params.data;
    return true;
  }
}

